import { Injectable } from '@angular/core';
import { ApiService, InterceptorConfig, RepositoryImpl } from '@homeleite/arch';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MilkControl } from './milk-control';
import { MilkControlSummary } from './milk-control-Summary';
import { AnimalEvent } from '../animals/events/animal-event';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class MilkControlsApiRepository extends RepositoryImpl<MilkControlSummary, MilkControl> {
    constructor(api: ApiService) {
        super(api.root.path('/milkControls'),
            MilkControlSummary,
            MilkControl
        );
    }

    /**
     * Projeção Mongo — não quebra com milkedAnimals inválido.
     * NO_INTERCEPT: em produção o endpoint pode não existir; o Admin faz fallback sem toast.
     */
    workByController(controllerId: string, limit = 24): Observable<ControllerWork> {
        const params = new HttpParams().set('controllerId', controllerId).set('limit', limit.toString());
        return this.api.path('workByController').getJson<ControllerWork>({
            params,
            metadata: { autoCatch: InterceptorConfig.NO_INTERCEPT }
        });
    }

    listSummariesByProducer(producerId: string): Observable<MilkControlSummary[]> {
        const params = new HttpParams().set('producerId', producerId);
        return this.api
            .path('summariesByProducer')
            .getJson<any[]>({
                params,
                metadata: { autoCatch: InterceptorConfig.NO_INTERCEPT }
            })
            .pipe(map((rows) => (rows || []).map((j) => MilkControlSummary.fromControlLike(j))));
    }

    /** Pacote ttScl para importar o controle no outro sistema (SRG-SCL). */
    exportImportJson(id: string): Observable<any> {
        return this.api.path('importJson', id).getJson<any>();
    }

    listEventsByControl(id: string): Observable<MilkControlEventsResponse> {
        return this.api.path('events', id).getJson<MilkControlEventsResponse>();
    }
}

export interface MilkControlEventStatus extends AnimalEvent {
    apiSaved: boolean;
    apiStatus?: 'SAVED' | 'FAILED';
    apiSavedAt?: string | null;
    apiError?: string | null;
    apiErrorCode?: number | null;
    srgStatus: 'PENDING' | 'SENT' | 'FAILED' | 'DISCARDED' | 'NOT_REQUIRED' | 'NOT_SENT';
    attempts?: number | null;
    queuedAt?: string | null;
    lastAttemptAt?: string | null;
    sentAt?: string | null;
    lastError?: string | null;
    srgSclCode?: string | null;
    srgSclReason?: string | null;
}

export interface ControllerControlRow {
    id: string;
    startedAt?: string | null;
    finishedAt?: string | null;
    status?: string | null;
    day?: string | null;
    official?: boolean;
    producerId?: string | null;
    producerCode?: string | null;
    producerName?: string | null;
    milkingsCount?: number;
    animals?: number;
    milkings?: { id: string; totalMilkedAnimals: number }[];
    sync?: 'OK' | 'FAIL' | 'NONE' | string;
}

export interface ControllerEventRow {
    at?: string | null;
    action?: string;
    entity?: string;
    sync?: 'OK' | 'FAIL' | 'NONE' | string;
    milkControlId?: string | null;
    producerId?: string | null;
}

export interface ControllerWork {
    controls: ControllerControlRow[];
    events: ControllerEventRow[];
}

export interface MilkControlEventsResponse {
    eventsReportedAt: string | null;
    items: MilkControlEventStatus[];
}
